export default class Notification {
	notify() {
		throw new Error("You have to implement the method notify.");
	}
}
